import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useUpdateUserProfile } from '../../data/userProfile';
import { generatePublicProfileUrl } from '../../utils/profileUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MakeProfilePublicModal = ({
  onClose,
  userProfile,
  trackInteraction
}) => {
  const publicUrl = generatePublicProfileUrl(userProfile.userId);
  const [hasConsent, setHasConsent] = useState(false);
  const [updateUserProfile, {
    loading: updateLoading
  }] = useUpdateUserProfile();
  const handleCopyLink = async () => {
    try {
      await updateUserProfile({
        variables: Object.assign({}, userProfile, {
          public: true
        })
      });
      onClose();
      trackInteraction('share-profile');
      FloatingAlertStore.addAlert({
        type: 'success',
        message: I18n.text('profilePage.share.messages.success')
      });
    } catch (error) {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: I18n.text('profilePage.share.messages.error')
      });
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: 450,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "profilePage.share.modal.title"
        })
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "400",
        textAlign: "start",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "profilePage.share.modal.description"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "consent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "profilePage.share.modal.consentLabel"
          })
        }), /*#__PURE__*/_jsx(Toggle, {
          checked: hasConsent,
          id: "consent",
          onChange: event => setHasConsent(event.target.checked),
          size: "small"
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(CopyButton, {
        disabled: !hasConsent || updateLoading,
        hint: "",
        onClick: () => void handleCopyLink(),
        use: "primary",
        value: publicUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "profilePage.share.modal.copyButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "profilePage.share.modal.cancelButton"
        })
      })]
    })]
  });
};